import * as React from 'react';

class SocialMediaTile extends React.Component {
  render() {
    return (
      <div className="social-media-tile">
        <a href={this.props.profileURL} target="_blank" rel="noreferrer" title={this.props.socialMedia} className={`fa fa-${this.props.socialIcon}`}></a> 
      </div>
    )
  }
}

export default SocialMediaTile;
